import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Link } from 'foundations-components/transitional/components/Link';
import { getAppMarketplaceUrl, getSolutionsDirectoryUrl, getTemplateMarketplaceUrl } from '../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CARD_BUTTON_HEIGHT = 240;
function CardButton({
  href,
  illustrationName,
  onClick,
  textLabel
}) {
  return /*#__PURE__*/_jsx(Link, {
    href: href,
    onClick: onClick,
    use: "unstyled",
    children: /*#__PURE__*/_jsx(CardWrapper, {
      compact: true,
      marginBlockEnd: "0",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        flexDirection: "column",
        gap: "800",
        padding: "800",
        children: [/*#__PURE__*/_jsx(Illustration, {
          height: 92,
          name: illustrationName
        }), /*#__PURE__*/_jsx(Text, {
          typography: "heading-100",
          textAlign: "center",
          children: textLabel
        })]
      })
    })
  });
}
export default function MarketplaceCardsSection({
  onTrackInteraction
}) {
  return /*#__PURE__*/_jsx(Flex, {
    "data-test-id": "marketplace-cards-section",
    justifyContent: "center",
    paddingInline: "800",
    paddingBlock: "1200",
    children: /*#__PURE__*/_jsxs(Flex, {
      maxInlineSize: "716px",
      gap: "400",
      justifyContent: "center",
      flexWrap: "wrap",
      children: [/*#__PURE__*/_jsx(CardButton, {
        href: getTemplateMarketplaceUrl(),
        illustrationName: "marketplace-theme",
        onClick: () => onTrackInteraction('click template homepage card button'),
        textLabel: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceUnified.sections.marketplaceButtons.templateMarketplaceTextLabel"
        })
      }), /*#__PURE__*/_jsx(CardButton, {
        href: getAppMarketplaceUrl(),
        illustrationName: "integrations",
        onClick: () => onTrackInteraction('click app marketplace card button'),
        textLabel: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceUnified.sections.marketplaceButtons.appMarketplaceTextLabel"
        })
      }), /*#__PURE__*/_jsx(CardButton, {
        href: getSolutionsDirectoryUrl(),
        illustrationName: "marketplace-solutions-directory",
        onClick: () => onTrackInteraction('click solutions directory card button'),
        textLabel: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceUnified.sections.marketplaceButtons.solutionsDirectoryTextLabel"
        })
      })]
    })
  });
}